const OUTDATED_APP_ERROR_MESSAGE = 'Loading chunk';
const OUTDATED_APP_CSS_ERROR_MESSAGE = 'Loading CSS chunk';
const OUTDATED_APP_ERROR_NAME = 'ChunkLoadError';
const OUTDATED_APP_REFRESH_TIME = 7000;
const OUTDATED_APP_COOKIE_NAME = 'outdated_app_refresh';

export {
	OUTDATED_APP_ERROR_MESSAGE,
	OUTDATED_APP_ERROR_NAME,
	OUTDATED_APP_REFRESH_TIME,
	OUTDATED_APP_COOKIE_NAME,
	OUTDATED_APP_CSS_ERROR_MESSAGE,
};
